import { DotCMSBlockEditorRenderer } from '@dotcms/react';
import Script from 'next/script';
import { useState, useEffect, useRef } from 'react';

function BookTime({ title, description }) {
    const [isVisible, setIsVisible] = useState(false);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !scriptLoaded) {
                    setIsVisible(true);
                    setScriptLoaded(true);
                }
            },
            { threshold: 0.1 }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => observer.disconnect();
    }, [scriptLoaded]);

    return (
        <section
            ref={containerRef}
            className="grid justify-between gap-6 px-8 py-16 md:grid-cols-[30%_60%]">
            <div className="prose mt-4 prose-h2:text-white">
                <h2>{title}</h2>
                <DotCMSBlockEditorRenderer className="mt-4" blocks={description} />
            </div>

            <div
                className="meetings-iframe-container"
                data-src="https://meetings.hubspot.com/stacey-reiss/round-robin-sales?embed=true"></div>

            {isVisible && (
                <Script
                    strategy="lazyOnload"
                    type="text/javascript"
                    crossOrigin="anonymous"
                    src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
                />
            )}
        </section>
    );
}

export default BookTime;
